/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetShipmentActivityDriverResponse } from '../models/GetShipmentActivityDriverResponse';
import type { GetShipmentActivitySummaryDriverResponse } from '../models/GetShipmentActivitySummaryDriverResponse';
import type { GetShipmentCurrentTrackedRouteDriverResponse } from '../models/GetShipmentCurrentTrackedRouteDriverResponse';
import type { GetShipmentIdsByJobIdResponseAdmin } from '../models/GetShipmentIdsByJobIdResponseAdmin';
import type { GetShipmentRoutesDriverResponse } from '../models/GetShipmentRoutesDriverResponse';
import type { GetShipmentsEarningDriverResponse } from '../models/GetShipmentsEarningDriverResponse';
import type { GetShipmentStatusLogsAdminResponse } from '../models/GetShipmentStatusLogsAdminResponse';
import type { ListOf1OfShipmentRouteAdminDto } from '../models/ListOf1OfShipmentRouteAdminDto';
import type { MonitoringShipmentAdminDto } from '../models/MonitoringShipmentAdminDto';
import type { Pagination1OfShipmentAdminListedDto } from '../models/Pagination1OfShipmentAdminListedDto';
import type { Pagination1OfShipmentDriverListedDto } from '../models/Pagination1OfShipmentDriverListedDto';
import type { PostCancelShipmentEtaRequest } from '../models/PostCancelShipmentEtaRequest';
import type { PostShipmentCompleteDriverRequest } from '../models/PostShipmentCompleteDriverRequest';
import type { ShipmentAdminDto } from '../models/ShipmentAdminDto';
import type { ShipmentClientDto } from '../models/ShipmentClientDto';
import type { ShipmentCustomerInfoAdminDto } from '../models/ShipmentCustomerInfoAdminDto';
import type { ShipmentDriverDto } from '../models/ShipmentDriverDto';
import type { ShipmentStatus } from '../models/ShipmentStatus';
import type { TransferShipmentRequestAdmin } from '../models/TransferShipmentRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShipmentsService {
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static getShipmentDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetShipmentsEarningDriverResponse OK
     * @throws ApiError
     */
    public static getShipmentsEarningDriver({
        fromDate,
        toDate,
    }: {
        fromDate: string,
        toDate: string,
    }): CancelablePromise<GetShipmentsEarningDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments/earning',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetShipmentRoutesDriverResponse OK
     * @throws ApiError
     */
    public static getShipmentRoutesDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetShipmentRoutesDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments/{id}/routes',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postReachBranchDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/reach-branch',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postPickedUpDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/picked-up',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postShipmentShippingDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/shipping',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postReachDestinationDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/reach-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @deprecated
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postShipmentShippedDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/shipped',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static postShipmentCompleteDriver({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostShipmentCompleteDriverRequest,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/shipments/{id}/complete',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfShipmentDriverListedDto OK
     * @throws ApiError
     */
    public static getShipmentsDriver({
        fromDate,
        toDate,
        statuses,
        page,
        limit,
    }: {
        fromDate?: string,
        toDate?: string,
        statuses?: Array<ShipmentStatus>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfShipmentDriverListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'statuses': statuses,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetShipmentActivitySummaryDriverResponse OK
     * @throws ApiError
     */
    public static getShipmentActivitySummaryDriver({
        fromDate,
        toDate,
    }: {
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetShipmentActivitySummaryDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments/activity-summary',
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetShipmentActivityDriverResponse OK
     * @throws ApiError
     */
    public static getShipmentActivityDriver({
        localTimeZoneIdentifier,
        fromDate,
        toDate,
    }: {
        localTimeZoneIdentifier: string,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetShipmentActivityDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/shipments/activity',
            query: {
                'localTimeZoneIdentifier': localTimeZoneIdentifier,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentClientDto OK
     * @throws ApiError
     */
    public static getShipmentClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<ShipmentClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/shipments/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns Pagination1OfShipmentAdminListedDto OK
     * @throws ApiError
     */
    public static getShipmentsAdmin({
        shipmentId,
        orderUserId,
        referenceCode,
        driverId,
        jobId,
        deliveryOrderId,
        status,
        jobBranchId,
        regionId,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        shipmentId?: string,
        orderUserId?: string,
        referenceCode?: string,
        driverId?: number,
        jobId?: string,
        deliveryOrderId?: string,
        status?: ShipmentStatus,
        jobBranchId?: number,
        regionId?: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfShipmentAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments',
            query: {
                'shipmentId': shipmentId,
                'orderUserId': orderUserId,
                'referenceCode': referenceCode,
                'driverId': driverId,
                'jobId': jobId,
                'deliveryOrderId': deliveryOrderId,
                'status': status,
                'jobBranchId': jobBranchId,
                'regionId': regionId,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns Pagination1OfShipmentAdminListedDto OK
     * @throws ApiError
     */
    public static getDriverEarningsAdmin({
        driverId,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        driverId: number,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfShipmentAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/driver/{driverId}/earnings',
            path: {
                'driverId': driverId,
            },
            query: {
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns ShipmentAdminDto OK
     * @throws ApiError
     */
    public static getShipmentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns ShipmentCustomerInfoAdminDto OK
     * @throws ApiError
     */
    public static getShipmentCustomerInfoAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ShipmentCustomerInfoAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{id}/customer-info',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns GetShipmentStatusLogsAdminResponse OK
     * @throws ApiError
     */
    public static getShipmentStatusesAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetShipmentStatusLogsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{id}/status-logs',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `TransferShipments`
     * @returns ShipmentAdminDto OK
     * @throws ApiError
     */
    public static transferShipmentAdmin({
        requestBody,
    }: {
        requestBody?: TransferShipmentRequestAdmin,
    }): CancelablePromise<ShipmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shipments/transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns ListOf1OfShipmentRouteAdminDto OK
     * @throws ApiError
     */
    public static getShipmentRoutesAdmin({
        shipmentId,
    }: {
        shipmentId: string,
    }): CancelablePromise<ListOf1OfShipmentRouteAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{shipmentId}/routes',
            path: {
                'shipmentId': shipmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetShipmentCurrentTrackedRouteDriverResponse OK
     * @throws ApiError
     */
    public static getShipmentCurrentTrackedDriverRouteAdmin({
        shipmentId,
    }: {
        shipmentId: string,
    }): CancelablePromise<GetShipmentCurrentTrackedRouteDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{shipmentId}/current-tracked-driver-route',
            path: {
                'shipmentId': shipmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageShipments`
     * @returns any OK
     * @throws ApiError
     */
    public static postRearrangeShipmentsByJobIdAdmin({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shipments/job/{jobId}/rearrange',
            path: {
                'jobId': jobId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ReCalculateDriverEarnings`
     * @returns any OK
     * @throws ApiError
     */
    public static postRecalculateDriverEarningAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shipments/{id}/recalculate-driver-earning',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewShipments`
     * @returns GetShipmentIdsByJobIdResponseAdmin OK
     * @throws ApiError
     */
    public static getShipmentIdsByJobIdAdmin({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<GetShipmentIdsByJobIdResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/job/{jobId}/shipmentids',
            path: {
                'jobId': jobId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns MonitoringShipmentAdminDto OK
     * @throws ApiError
     */
    public static getMonitoringShipmentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<MonitoringShipmentAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/shipments/{id}/monitoring',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `CancelShipments`
     * @returns ShipmentAdminDto OK
     * @throws ApiError
     */
    public static postCancelShipmentAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelShipmentEtaRequest,
    }): CancelablePromise<ShipmentAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shipments/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WithdrawalDriverPouch`
     * @returns any OK
     * @throws ApiError
     */
    public static postSyncPouchOperationForShipmentAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/shipments/{id}/sync-pouch-operation',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
